// Auto-generated by scripts/write-build-info.js — DO NOT EDIT.
// Regenerated on every build/deploy. Gitignored.
const BUILD_INFO = {
  "sha": "414e813da51cdf37285c4deb70e215e6c0c77816",
  "shaShort": "414e813",
  "branch": "main",
  "time": "2026-11-03T18:39:42.915Z"
};

module.exports = BUILD_INFO;
module.exports.default = BUILD_INFO;
